import { render, staticRenderFns } from "./MoleculeContentBlock.vue?vue&type=template&id=3e71f5c8&"
import script from "./MoleculeContentBlock.vue?vue&type=script&lang=ts&"
export * from "./MoleculeContentBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports